<template>
  <div class="card height-100">
    <header class="header-card">
      <p>
        {{ $t('detailSociete.delaiAdministratif.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-4">
          <b-field :label="$t('detailSociete.delaiAdministratif.vente')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.delaiAdministratifVente}}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailSociete.delaiAdministratif.achat')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.delaiAdministratifAchat}}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
};
</script>
